import React, { Component } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import ClaimInformationSection from "./components/section/claimInformationSection";
import CustomerInformationSection from "./components/section/customerInformationSection";
import ClaimPartSection from "./components/section/claimPartSection";
import { Line } from "./components/line";
import { INITIAL_DATA_CLAIM_PART, SUCCESS_ALERT_MESSAGE } from "./constant";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { contructQueryParam, fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import {
  ACTIVITY_TYPE,
  GenericSequenceType,
  HttpStatus,
} from "../../common/Constants";
import { flattenFormGroupObject, mapToObjectDDL } from "../../common/mapper";
import withFormGroup from "../../../modules/commons/withFormGroup";
import ModalNomorBBM from "./components/modal/modalNomorBBM";
import ModalBKKBBK from "./components/modal/modalBKKBBK";
import ModalDataCustomer from "./components/modal/modalDataCustomer";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import {
  constructContentAlert,
  constructPayloadSubmit,
  handlePopulateDataAfterCheck,
  handleResetAutoPopulateData,
  populateInitialData,
} from "./utils";
import * as R from "ramda";

class ManagementClaimDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      totalHet: 0,
      totalOngkosKerja: 0,
      totalAmount: 0,
      kodeVariantOptions: [],
      namaVariantOptions: [],
      kodeWarnaOptions: [],
      namaWarnaOptions: [],
      provinceOptions: [],
      kabkotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      zipCodeOptions: [],
      zipCodeRaw: [],
      namaPelaporOptions: [],
      modalBBMVisibility: false,
      modalBKKBBKVisibility: false,
      modalDataCustomer: false,
      placeholderIdClaim: null,
      isAutoPopulatedData: false,
      alertInfo: {
        title: null,
        content: null,
        visible: false,
        type: "info",
      },
      isAutoPopulatedC1Data: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.totalHet !== this.state.totalHet ||
      prevState?.totalOngkosKerja !== this.state.totalOngkosKerja
    ) {
      this.setState({
        totalAmount:
          Number(this.state.totalHet) + Number(this.state.totalOngkosKerja),
      });
    }
    const prevControls = flattenFormGroupObject(prevProps?.controls);
    const currControls = flattenFormGroupObject(this.props.controls);
    if (
      currControls?.kodeVarian?.value &&
      currControls?.kodeVarian?.value !== prevControls?.kodeVarian?.value
    ) {
      this.fetchDataWarna(currControls?.kodeVarian?.value);
    }

    if (!this.state.isAutoPopulatedC1Data) {
      if (
        prevControls?.province?.value !== currControls.province?.value &&
        currControls.province?.value
      ) {
        this.fetchDataKabKot(currControls.province?.value);
      }
      if (
        prevControls?.kabkot?.value !== currControls.kabkot?.value &&
        currControls.kabkot?.value
      ) {
        this.fetchDataKecamatan(currControls.kabkot?.value);
      }
      if (
        prevControls?.kecamatan?.value !== currControls.kecamatan?.value &&
        currControls.kecamatan?.value
      ) {
        this.fetchDataKelurahan(currControls.kecamatan?.value);
      }
      if (
        (prevControls?.kelurahan?.value !== currControls.kelurahan?.value &&
          this.state.zipCodeRaw?.length > 0) ||
        this.state.zipCodeRaw?.length !== prevState?.zipCodeRaw?.length
      ) {
        const data = this.state.zipCodeRaw.find(
          (item) => item.id === currControls.kelurahan?.value
        );
        this.setDataOptions(
          "zipCodeOptions",
          data ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []
        );
      }
    }
  }

  handleAddDataTableClaimPart = () => {
    this.setState((prev) => ({
      ...prev,
      dataTable: [...prev.dataTable, INITIAL_DATA_CLAIM_PART],
    }));
  };

  handleEditDataTableClaimPart = (index) => {
    this.setState((prev) => {
      const data = [...prev.dataTable];

      data[index] = {
        ...data[index],
        isSaved: false,
      };
      return {
        ...prev,
        dataTable: data,
      };
    });
  };

  handleSaveDataTableClaimPart = (index) => {
    if (this.checkDataPart(index)) {
      this.setState((prev) => ({
        ...prev,
        alertInfo: {
          title: "Peringatan",
          content: "Ada Field Yang Belum Diisi",
          visible: true,
          type: "info",
        },
      }));
    } else {
      this.setState((prev) => {
        const data = [...prev.dataTable];

        data[index] = {
          ...data[index],
          isSaved: true,
        };
        return {
          ...prev,
          dataTable: data,
          totalHet: data?.reduce(
            (curr, next) => curr + Number(next?.hetReal),
            0
          ),
          totalOngkosKerja: data?.reduce(
            (curr, next) => curr + Number(next?.ongkosKerja),
            0
          ),
        };
      });
    }
  };

  checkDataPart = (index) => {
    const d = this.state.dataTable[index];
    console.log("data", d);
    let check = false;
    if (R.isNil(d.kodePart) || R.isEmpty(d.kodePart)) check = true;
    if (R.isNil(d.namaPart) || R.isEmpty(d.namaPart)) check = true;
    if (R.isNil(d.qty) || R.isEmpty(d.qty)) check = true;
    if (R.isNil(d.hetReal) || R.isEmpty(d.hetReal)) check = true;
    if (R.isNil(d.ongkosKerja) || R.isEmpty(d.ongkosKerja)) check = true;
    return check;
  };

  handleDeleteDataTableClaimPart = (index) => {
    this.setState((prev) => ({
      ...prev,
      totalHet: prev.totalHet - Number(prev.dataTable[index]?.hetReal),
      totalOngkosKerja:
        prev.totalOngkosKerja - Number(prev.dataTable[index]?.ongkosKerja),
      dataTable: prev.dataTable?.filter((_, idx) => index !== idx),
    }));
  };

  handleChangeDataTableValue = (index, name, value) => {
    this.setState((prev) => {
      const data = [...prev.dataTable];

      data[index] = {
        ...data[index],
        [name]: value,
      };
      return {
        ...prev,
        dataTable: data,
      };
    });
  };

  loadData = async () => {
    const {
      setError,
      onTriggerLoading,
      initialValues,
      selectedCabang,
      setValue,
    } = this.props;
    const userId = localStorage.getItem("userId");
    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
        setError: setError,
        menuName: "Management Claim",
        args: {},
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
        setError: setError,
        menuName: "Management Claim",
        args: {},
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getNamaPelaporManagementClaim,
        setError: setError,
        menuName: "Management Claim",
        args: {
          idUser: userId,
          kodeCabang: selectedCabang?.value,
        },
      }),
    ];

    if (!initialValues) {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave,
          menuName: "Management Claim",
          setError: setError,
          args: {
            seqType: GenericSequenceType.MANAGEMENT_CLAIM,
            nosDealerCode: selectedCabang?.value,
            transactionType: GenericSequenceType.MANAGEMENT_CLAIM,
          },
        })
      );
    } else {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailManagementClaim,
          menuName: "Management Claim",
          setError: setError,
          args: {
            id: initialValues,
          },
        })
      );
    }

    onTriggerLoading();
    const res = await Promise.all(promises);
    onTriggerLoading();
    if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        // mapToObjectDDL(item.kodeVariant, item.kodeVariant)
        kodeVariantOptions: res[0].data.data.map((item) => ({
          label: item.kodeVariant,
          value: item.kodeVariant,
          namaVariant: item.namaVariant,
        })),
        namaVariantOptions: res[0].data.data.map((item) =>
          // mapToObjectDDL(item.namaVariant, item.kodeVariant)
          ({
            label: item.namaVariant,
            value: item.namaVariant,
            kodeVariant: item.kodeVariant,
          })
        ),
      }));
    }
    if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        provinceOptions: res[1].data.data.map((item) =>
          mapToObjectDDL(item.provinceName, item.id)
        ),
      }));
    }

    if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        namaPelaporOptions: res[2].data.data.map((item) =>
          mapToObjectDDL(item.name, item.employeeId)
        ),
      }));
    }

    if (!initialValues) {
      if (res[3]?.ok && res[3]?.data) {
        this.setState({
          placeholderIdClaim: res[3].data,
        });
      }
    } else {
      if (res[3]?.ok && res[3]?.data.status === HttpStatus.SUCCESS) {
        populateInitialData(res[3].data.data, setValue);
        this.setState((prev) => ({
          ...prev,
          dataTable: res[3].data.data.listDetail.map((item) => ({
            ...item,
            kodePart: mapToObjectDDL(item.part.kodePart, item.part.kodePart),
            namaPart: mapToObjectDDL(item.part.partName, item.part.partName),
            kategori: mapToObjectDDL(
              item.part.partCategory.value,
              item.part.partCategory.value
            ),
            isSaved: true,
          })),
          totalHet: res[3].data.data.listDetail?.reduce(
            (curr, next) => curr + Number(next?.hetReal),
            0
          ),
          totalOngkosKerja: res[3].data.data.listDetail?.reduce(
            (curr, next) => curr + Number(next?.ongkosKerja),
            0
          ),
        }));
      }
    }
  };

  fetchDataWarna = async (value) => {
    const { onTriggerLoading } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: { paramFilters: { kodeVariant: value } },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        kodeWarnaOptions: res.data.data.map((item) =>
          // mapToObjectDDL(item.kodeWarna, item.kodeWarna)
          ({
            label: item.kodeWarna,
            value: item.kodeWarna,
            namaWarnaKomersil: item.namaWarnaKomersil,
            id: item.id,
          })
        ),
        namaWarnaOptions: res.data.data.map((item) =>
          // mapToObjectDDL(item.namaWarnaKomersil, item.id)
          ({
            label: item.namaWarnaKomersil,
            value: item.id,
            kodeWarna: item.kodeWarna,
          })
        ),
      }));
    }
  };

  fetchDataKabKot = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const result = response.data.data.map((item) =>
        mapToObjectDDL(item.kabKotName, item.kabKotId)
      );
      this.setDataOptions("kabkotOptions", result);
    }
  };

  fetchDataKecamatan = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const result = response.data.data.map((item) =>
        mapToObjectDDL(item.kecamatanName, item.id)
      );
      this.setDataOptions("kecamatanOptions", result);
    }
  };

  fetchDataKelurahan = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const result = response.data.data.map((item) =>
        mapToObjectDDL(item.kelurahanname, item.id)
      );
      this.setDataOptions("kelurahanOptions", result);
      this.setDataOptions("zipCodeRaw", response.data.data);
      if (this.state.isAutoPopulatedC1Data) {
        this.setState({
          isAutoPopulatedC1Data: false,
        });
      }
    }
  };

  setDataOptions = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  handleModalAddBBMVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      modalBBMVisibility: !prev.modalBBMVisibility,
    }));
  };

  handleModalBKKBBKVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      modalBKKBBKVisibility: !prev.modalBKKBBKVisibility,
    }));
  };

  handleModalDataCustomerVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      modalDataCustomer: !prev.modalDataCustomer,
    }));
  };

  checkUnit = async ({ noka, nosin }) => {
    const { onTriggerLoading, setError, selectedCabang, controls, setValue } =
      this.props;
    const formData = flattenFormGroupObject(controls);
    const kodeCabang =
      formData?.tipePengajuan?.value === "C2" ? selectedCabang?.value : null;

    if (!formData?.tipePengajuan?.value) {
      this.handleAlertInfo(
        "Informasi",
        "Silahkan pilih tipe pengajuan terlebih dahulu!"
      );
      return;
    }
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkUnitManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: {
        nomorRangka: noka,
        nomorMesin: nosin,
        kodeCabang: kodeCabang,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (res.data.data) {
        this.setState({
          isAutoPopulatedData: true,
        });
        handlePopulateDataAfterCheck(res.data.data, setValue, true);
        this.handleAlertInfo("Informasi", "Data unit ada di Database");
        return;
      }
      this.setState({
        isAutoPopulatedData: false,
      });
      this.handleAlertInfo("Informasi", "Data unit tidak ada di Database");
    }
  };

  handleAlertInfo = (title, content, type) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        title: title,
        content: content,
        visible: !prev.alertInfo.visible,
        type: type || "info",
      },
    }));
  };

  handleResetLocationOptions = (name) => {
    const { setValue } = this.props;
    if (name === "province") {
      setValue("kabkot", null);
      setValue("kelurahan", null);
      setValue("kecamatan", null);
      setValue("zipcode", null);

      this.setDataOptions("kabkotOptions", []);
      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }

    if (name === "kabkot") {
      setValue("kelurahan", null);
      setValue("kecamatan", null);
      setValue("zipcode", null);

      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }
    if (name === "kecamatan") {
      setValue("kelurahan", null);
      setValue("zipcode", null);

      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }
  };

  handleAccept = () => {
    const { alertInfo } = this.state;
    this.handleAlertInfo();
    if (alertInfo.type === "confirm-submit") {
      return this.handleProcessSubmit();
    }
    if (alertInfo.type === "confirm-delete") {
      return this.handleProcessDelete();
    }
  };

  handleProcessSubmit = async () => {
    const {
      onTriggerLoading,
      setError,
      controls,
      selectedCabang,
      tabCode,
      onRefresh,
      activityType,
    } = this.props;
    const { dataTable } = this.state;
    const formData = flattenFormGroupObject(controls);
    const payload = constructPayloadSubmit({
      ...formData,
      dataTable: dataTable,
      kodeCabang: selectedCabang?.value,
      tab: tabCode,
    });
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").saveUpdateManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertInfo(
        "Informasi",
        SUCCESS_ALERT_MESSAGE[activityType],
        "success"
      );
      onRefresh();
    }
  };

  handleProcessDelete = async () => {
    const { onTriggerLoading, setError, controls, onRefresh } = this.props;
    const formData = flattenFormGroupObject(controls);
    const payload = {
      id: formData?.id,
      claimManagementId: formData?.idClaim,
      status: "INACTIVE",
    };
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").updateStatusManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertInfo("Informasi", "Data Berhasil Dihapus", "success");
      onRefresh();
    }
  };

  handleCheckNIK = async (nik) => {
    const { setError, onTriggerLoading, setValue } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNIKSalesOrder,
      setError: setError,
      menuName: "Management Claim",
      args: contructQueryParam({ nik }),
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (res.data.data) {
        this.handleAlertInfo("Informasi", "Data Customer ada di Database");
        this.setState({
          isAutoPopulatedData: true,
        });
        handlePopulateDataAfterCheck(res.data.data, setValue);
      } else {
        this.handleAlertInfo(
          "Informasi",
          "Data Customer tidak ada di Database"
        );
        this.setState({
          isAutoPopulatedData: false,
        });
      }
    }
  };

  handleSave = () => {
    const { controls, validate, activityType, tabCode } = this.props;
    const { dataTable } = this.state;
    const isView = activityType === ACTIVITY_TYPE.VIEW;

    const tipePengajuan = controls?.tipePengajuan?.value?.value;
    if (tipePengajuan === "C2" && !controls?.nik?.value) {
      this.handleAlertInfo("Informasi", "NIK wajib diisi!");
      return;
    }
    if (dataTable?.find((item) => item.isSaved === false)) {
      this.handleAlertInfo(
        "Informasi",
        "Terdapat data pada tabel yang belum disimpan. Harap simpan perubahan!"
      );
      return;
    }

    if (R.isNil(dataTable) || R.isEmpty(dataTable)) {
      this.handleAlertInfo(
        "Informasi",
        "Data part pada tabel masih kosong. Harap tambah data!"
      );
      return;
    }

    if (!isView && !validate()) {
      return;
    }

    const { placeholderIdClaim } = this.state;
    const formData = flattenFormGroupObject(controls);
    const content = constructContentAlert({
      formData,
      activityType,
      placeholderIdClaim,
      tab: tabCode,
    });
    this.handleAlertInfo("Konfirmasi", content, "confirm-submit");
  };

  handleDeleteDocument = () => {
    const { controls } = this.props;

    const formData = flattenFormGroupObject(controls);
    const content = (
      <div style={{ textAlign: "start" }}>
        <p>Data claim berikut</p>
        <br />
        <p>Tipe Claim: {formData.tipePengajuan?.value}</p>
        <p>ID Claim: {formData?.idClaim}</p>
        <p>Nomor Claim: {formData?.nomorClaim}</p>
        <p>Nama Pemilik: {formData?.namaPemilik}</p>
        <br />
        <p>Akan dihapus. Apakah anda yakin?</p>
      </div>
    );
    this.handleAlertInfo("Konfirmasi", content, "confirm-delete");
  };

  handleCancelAutoPopulate = (type) => {
    const { setValue } = this.props;
    const { isAutoPopulatedData } = this.state;
    console.log(isAutoPopulatedData, type);

    if (isAutoPopulatedData) {
      this.setState({
        isAutoPopulatedData: false,
      });
      handleResetAutoPopulateData(setValue);
    } else {
      if (type === "noka") {
        setValue("nomorRangka", null);
      }
      if (type === "nosin") {
        setValue("nomorMesin", null);
      }
    }
  };

  handlePopulateC1Data = async () => {
    const { setValue, selectedCabang, onTriggerLoading, setError } = this.props;
    this.setState({
      isAutoPopulatedC1Data: true,
    });

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getDataCabangForManagementClaim,
      setError: setError,
      menuName: "Management Claim",
      args: {
        kodeCabang: selectedCabang?.value,
      },
    });
    if (!res.ok && res.data.status !== HttpStatus.SUCCESS && !res.data.data) {
      onTriggerLoading();
      return;
    }
    const data = res.data.data;

    setValue("namaPemilik", data.namaCabang);
    setValue("alamat", data.alamat);
    setValue(
      "province",
      mapToObjectDDL(data.provinsi.provinceName, data.provinsi.id)
    );

    setValue(
      "kabkot",
      mapToObjectDDL(data.kabKot.kabKotName, data.kabKot.kabKotId)
    );

    setValue(
      "kecamatan",
      mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
    );
    setValue(
      "kelurahan",
      mapToObjectDDL(data.kelurahan.kelurahanname, data.kelurahan.id)
    );
    setValue("zipcode", {
      label: data.kodePos,
      value: data.kodePos,
    });
    setValue("nomorHp1", data.nomorHp1);
    if (data.kodePos) {
      this.setDataOptions(
        "zipCodeOptions",
        [mapToObjectDDL(data.kodePos, data.kodePos)]
      );
    }

    await Promise.all([
      this.fetchDataKabKot(data.provinsi.id),
      this.fetchDataKecamatan(data.kabKot.kabKotId),
      this.fetchDataKelurahan(data.kecamatan.id),
    ]);
    onTriggerLoading();
  };

  render() {
    const { visible, onClickClose, activityType } = this.props;
    const {
      modalBBMVisibility,
      modalBKKBBKVisibility,
      modalDataCustomer,
      alertInfo,
    } = this.state;
    console.log(this.state);
    return (
      <SimpleModal
        title="Detail Manajemen Claim"
        visible={visible}
        styles={{ width: "90%" }}
        onClickClose={onClickClose}
        content={
          <React.Fragment>
            <ModalContainer>
              <ClaimInformationSection
                {...this.props}
                {...this.state}
                onPopulateC1Data={this.handlePopulateC1Data}
                onCancelAutoPopulate={this.handleCancelAutoPopulate}
                onCheckUnit={this.checkUnit}
                onOpenModalBKKBBK={this.handleModalBKKBBKVisibility}
                onOpenModalBBM={this.handleModalAddBBMVisibility}
              />
              <Line />
              <CustomerInformationSection
                {...this.props}
                {...this.state}
                onCheckNIK={this.handleCheckNIK}
                onResetLocationOptions={this.handleResetLocationOptions}
                onOpenModalDataCustomer={this.handleModalDataCustomerVisibility}
              />
              <Line />
              <ClaimPartSection
                {...this.props}
                {...this.state}
                onChangeData={this.handleChangeDataTableValue}
                onSaveData={this.handleSaveDataTableClaimPart}
                onEditData={this.handleEditDataTableClaimPart}
                onDeleteData={this.handleDeleteDataTableClaimPart}
                onAddData={this.handleAddDataTableClaimPart}
              />
              <FlexView hAlignContent="right" style={{ marginTop: "20px" }}>
                {activityType === ACTIVITY_TYPE.DELETE ? (
                  <SimpleButton
                    text="HAPUS"
                    onClick={() => this.handleDeleteDocument()}
                  />
                ) : (
                  <SimpleButton
                    text={
                      activityType === ACTIVITY_TYPE.VIEW
                        ? "LENGKAPI"
                        : "SIMPAN"
                    }
                    onClick={() => this.handleSave()}
                  />
                )}
              </FlexView>
            </ModalContainer>
            {modalBBMVisibility && (
              <ModalNomorBBM
                {...this.props}
                onClickClose={this.handleModalAddBBMVisibility}
                visible={modalBBMVisibility}
              />
            )}
            {modalBKKBBKVisibility && (
              <ModalBKKBBK
                {...this.props}
                onClickClose={this.handleModalBKKBBKVisibility}
                visible={modalBKKBBKVisibility}
              />
            )}
            {modalDataCustomer && (
              <ModalDataCustomer
                {...this.props}
                onClickClose={this.handleModalDataCustomerVisibility}
                visible={modalDataCustomer}
              />
            )}
            {alertInfo.visible && (
              <SimpleAlert
                visible={alertInfo.visible}
                title={alertInfo.title}
                content={alertInfo.content}
                onClickClose={() => this.handleAlertInfo()}
                additionalButtons={
                  alertInfo.type === "info" || alertInfo.type === "success" ? (
                    <SimpleButton
                      text="OK"
                      onClick={() => {
                        if (alertInfo.type === "success") {
                          onClickClose();
                        }
                        this.handleAlertInfo();
                      }}
                    />
                  ) : (
                    <FlexView>
                      <SimpleButton
                        text="Tidak"
                        onClick={() => this.handleAlertInfo()}
                      />
                      <SimpleButton
                        text="Ya"
                        onClick={() => this.handleAccept()}
                      />
                    </FlexView>
                  )
                }
              />
            )}
          </React.Fragment>
        }
      />
    );
  }
}

export default withFormGroup(ManagementClaimDetail);
